import { render, staticRenderFns } from "./postAd.vue?vue&type=template&id=ae3be9f6&scoped=true&"
import script from "./postAd.vue?vue&type=script&lang=js&"
export * from "./postAd.vue?vue&type=script&lang=js&"
import style0 from "./postAd.vue?vue&type=style&index=0&id=ae3be9f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3be9f6",
  null
  
)

export default component.exports